import React, { useState, useCallback } from 'react';
import {
  Modal,
  Button,
  DisplayText,
  TextContainer
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { injectIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';

function DeleteModal(props) {
  const [active, setActive] = useState(false);
  const {
    intl,
    modalActivator,
    variant = 'default',
    iconSize,
    sectioned = true,
    disableActivator = false,
    rerenderActivator = false,
    primaryAction = {}
  } = props;
  const handleChange = useCallback(
    () => !disableActivator && setActive(!active),
    [active, rerenderActivator, disableActivator]
  );

  const handleDelete = useCallback(() => {
    if (props.handleDeleteConfirmation) {
      props.handleDeleteConfirmation();
    }
    handleChange();
  });

  return (
    <div>
      {modalActivator ? (
        <div className="ptr" onClick={handleChange} id={props.id}>
          {modalActivator}
        </div>
      ) : (
        <Button
          onClick={handleChange}
          id={props.id}
          superid={props.id}
          destructive={props?.destructive}
          plain={props?.plain}
          disabled={disableActivator}
          icon={
            <div id="delete-modal">
              <SVGIcon name="Delete" />
            </div>
          }
        >
          {props?.noIcon && 'Delete'}
        </Button>
      )}
      <Modal
        open={active}
        onClose={handleChange}
        title={props.title || 'Delete confirmation'}
        primaryAction={{
          destructive: true,
          content:
            props.primaryContent || getTranslatedText(intl, 'common.delete'),
          onAction: handleDelete,
          ...primaryAction
        }}
        secondaryActions={[
          {
            content: getTranslatedText(intl, 'common.cancel'),
            onAction: handleChange,
            plainSecondary: true
          }
        ]}
        variant={variant}
        iconSize={iconSize}
      >
        {sectioned ? (
          <Modal.Section>
            <TextContainer>
              <DisplayText element="p" size="large">
                {props.description || 'Are you sure?'}
              </DisplayText>
            </TextContainer>
          </Modal.Section>
        ) : (
          <TextContainer>
            <span className="mt5">
              <DisplayText element="p" size="large">
                {props.description || 'Are you sure?'}
              </DisplayText>
            </span>
          </TextContainer>
        )}
      </Modal>
    </div>
  );
}

export default injectIntl(DeleteModal);
